<template>
  <div class="invoice-clearing-list">
    <div
      v-for="(value, key) of statement.pdfJson"
      :key="key"
      class="item border-bottom"
      @click="view(value, key)"
    >
      <div>{{ key }} 结算单</div>
      <div>查看 >></div>
    </div>
  </div>
</template>

<script>
import { WSBridge } from '@/utils/utils'
export default {
  data() {
    return {
      statement: this.$route.query.statement
    }
  },
  created() {
    SyHybridSdk.setNavigationBarTitle({
      params: {
        title: '结算单'
      },
      success: res => {}
    })
    if (Object.prototype.toString.call(this.statement) === '[object String]') {
      this.statement = JSON.parse(this.statement)
    }
  },
  methods: {
    view(url, key) {
      this.$router.push({
        path: 'invoice-statement',
        query: {
          url: url,
          params: JSON.stringify(this.statement.paramJson[key])
        }
      })
      // WSBridge.openWebView({
      //   params: {
      //     url: `http://hybrid-h5.qianziworth.cn/worthpay/partner/#/invoice-statement?url=${url}`,
      //     style: '1',
      //     orientation: '2'
      //   },
      //   success: res => {}
      // })
    }
  }
}
</script>
